import React, { useMemo, memo } from 'react';
import cn from 'classnames';
import styles from './DateRangePickerFooter.module.scss';
import { Icon, Button } from 'antd';
import { ranges } from './constants';

const DateRangePickerFooter = ({
  onRangeClick,
  onRangeHover,
  disabled,
  storedSelectedRange,
  isActiveFn,
  rootClassName,
}) => {
  const showWeekForward = true;

  const rangesTags = useMemo(
    () =>
      ranges(showWeekForward).map((range) => {
        const isDisabled = !range.range || disabled;

        const isActive = storedSelectedRange
          ? storedSelectedRange.id === range.id
          : typeof isActiveFn === 'function'
          ? isActiveFn(range)
          : undefined;

        const classNames = isActive
          ? `${styles.buttonRange} ${styles.buttonRangeActive}`
          : styles.buttonRange;

        return (
          <Button
            key={range.id}
            size={'small'}
            className={classNames}
            onClick={() => !isDisabled && onRangeClick(range)}
            //onMouseEnter={() => {
            //onRangeHover(range);
            //}}
            disabled={disabled}
          >
            {range.name}
            {range.icon && <Icon type={range.icon} className={styles.icon} />}
          </Button>
        );
      }),
    [storedSelectedRange, disabled]
  );

  return (
    <div className={cn(styles.dateRangePickerFooter, rootClassName)}>
      {rangesTags}
    </div>
  );
};

export default memo(DateRangePickerFooter);
